import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DataService {
  [x: string]: any;

  genders = [
    { id: 1, value: 1, name: 'Male' },
    { id: 2, value: 2, name: 'Female' },
    { id: 3, value: 3, name: 'LGBTQ' },
  ];

  travelType = [
    { id: 1, value: 1, name: 'Adult' },
    { id: 2, value: 2, name: 'Child' },
    { id: 3, value: 3, name: 'Infant' },
  ]

  title = [
    { id: 1, name: 'Mr.' },
    { id: 2, name: 'Ms.' },
    { id: 3, name: 'Mrs.' },
    { id: 4, name: 'Mstr.' },
  ];

  payment_option = [
    { id: 1, name: 'Debit/Credit Card' },
    { id: 2, name: 'Wallet' },
    { id: 3, name: 'Upi' },
    { id: 4, name: 'Net Banking' },
  ];

  upi = [
    {
      id: 1,
      icon: 'paytm.png',
      name: 'Paytm',
      value: 'PAYTM',
      message:
        'Get upto ₹ 200 cashback on domestic flights. Use promo code: CTMBK200',
    },
    {
      id: 2,
      icon: 'freeCharge.png',
      name: 'Freecharge',
      value: 'FREC',
      message: '',
    },
    { id: 3, icon: '', name: 'Amazon Pay', value: 'AMZPAY', message: '' },
    {
      id: 4,
      icon: 'airtel_money.png',
      name: 'Airtel Money',
      value: 'AMON',
      message: '',
    },
    {
      id: 5,
      icon: 'oxigenwallet.png',
      name: 'Oxigen',
      value: 'OXYCASH',
      message: '',
    },
    {
      id: 6,
      icon: 'ola_money.png',
      name: 'Ola Money',
      value: 'OLAM',
      message: '',
    },
    {
      id: 7,
      icon: 'jioMoney.png',
      name: 'Jio Money',
      value: 'JIOM',
      message: '',
    },
    { id: 8, icon: '', name: 'ItzCash', value: 'ITZC', message: '' },
    {
      id: 9,
      icon: 'hdfc.png',
      name: 'HDFC PayZapp',
      value: 'PAYZ',
      message: '',
    },
    { id: 10, icon: '', name: 'Yes Bank', value: 'YESW', message: '' },
  ];

  net_banking = [
    {
      name: 'AXIS Bank',
      code: 'AXIB',
      logo: '\\img\\payoptions\\nbAXIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'Bank of Maharashtra',
      code: 'BOMB',
      logo: '\\img\\payoptions\\nbBOMB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'Central Bank of India',
      code: 'CBIB',
      logo: '\\img\\payoptions\\nbCBIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'HDFC Bank',
      code: 'HDFB',
      logo: '\\img\\payoptions\\nbHDFB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'ICICI Netbanking',
      code: 'ICIB',
      logo: '\\img\\payoptions\\nbICIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'IDBI Bank',
      code: 'IDBB',
      logo: '\\img\\payoptions\\nbIDBB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'Union Bank of India',
      code: 'UBIB',
      logo: '\\img\\payoptions\\nbUBIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'State Bank of India',
      code: 'SBIB',
      logo: '\\img\\payoptions\\nbSBIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'AXIS Bank',
      code: 'AXIB',
      logo: '\\img\\payoptions\\nbAXIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'Bank of Maharashtra',
      code: 'BOMB',
      logo: '\\img\\payoptions\\nbBOMB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'Central Bank of India',
      code: 'CBIB',
      logo: '\\img\\payoptions\\nbCBIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'ICICI Netbanking',
      code: 'ICIB',
      logo: '\\img\\payoptions\\nbICIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'HDFC Bank',
      code: 'HDFB',
      logo: '\\img\\payoptions\\nbHDFB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'IDBI Bank',
      code: 'IDBB',
      logo: '\\img\\payoptions\\nbIDBB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'Union Bank of India',
      code: 'UBIB',
      logo: '\\img\\payoptions\\nbUBIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'State Bank of India',
      code: 'SBIB',
      logo: '\\img\\payoptions\\nbSBIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'Bank of India',
      code: 'BOIB',
      logo: '\\img\\payoptions\\nbBOIB.png',
      promoword: '',
      index: 99,
    },
    {
      name: 'Bank of India',
      code: 'BOIB',
      logo: '\\img\\payoptions\\nbBOIB.png',
      promoword: '',
      index: 99,
    },
  ];

  getMonth = [
    { name: 'January', code: 'Jan', value: '01' },
    { name: 'February', code: 'Feb', value: '02' },
    { name: 'March', code: 'Mar', value: '03' },
    { name: 'April', code: 'Apr', value: '04' },
    { name: 'May', code: 'May', value: '05' },
    { name: 'June', code: 'Jun', value: '06' },
    { name: 'July', code: 'Jul', value: '07' },
    { name: 'August', code: 'Aug', value: '08' },
    { name: 'September', code: 'Sep', value: '09' },
    { name: 'October', code: 'Oct', value: '10' },
    { name: 'November', code: 'Nov', value: '11' },
    { name: 'December', code: 'Dec', value: '12' },
  ];
  getYear = [
    '2023',
    '2024',
    '2025',
    '2026',
    '2027',
    '2028',
    '2029',
    '2030',
    '2031',
    '2032',
    '2033',
    '2034',
    '2035',
    '2036',
    '2037',
    '2038',
    '2039',
    '2040',
    '2041',
  ];

  document_type = [
    { id: 1, name: 'Aadhaar Card' },
    { id: 2, name: 'PAN Card' },
    { id: 3, name: 'Passport' },
  ];

  itaIcon = [
    { name: 'iat', path: 'assets/main/iat.png' },
    { name: 'iatomem', path: 'assets/main/iatomem.png' },
    { name: 'ministry', path: 'assets/main/ministry.png' },
    { name: 'pat', path: 'assets/main/pat.png' },
    { name: 'taf', path: 'assets/main/taf.png' },
    { name: 'tai', path: 'assets/main/tai.png' },
    { name: 'ufta', path: 'assets/main/ufta.png' },
  ];

  paymentIcon = [
    { name: 'global', path: 'assets/belairtrip_assets/svg_icon/goglobal-logo.png' },
    { name: 'loy', path: 'assets/main/loy.png' },
    { name: 'amer', path: 'assets/main/amer.png' },
    { name: 'visa', path: 'assets/main/visa.png' },
    { name: 'mas', path: 'assets/main/mas.png' },
    { name: 'veri', path: 'assets/main/veri.png' },
  ];

  socialMedia = [
    { name: 'Email', icon: 'fa fa-envelope', path: 'mailto:support@belairtrip.com' },
    {
      name: 'facebook',
      icon: 'fa fa-facebook-f',
      path: 'https://www.facebook.com/belairtrips',
    },
    {
      name: 'linkedin',
      icon: 'fa fa-linkedin',
      path: 'https://www.linkedin.com/company/belairtrip/',
    },
    {
      name: 'twitter',
      icon: 'fa-brands fa-x-twitter fa-xl',
      path: 'https://x.com/belair_trip',
    },
    {
      name: 'instagram',
      icon: 'fa fa-instagram',
      path: 'https://www.instagram.com/belairtrip/',
    },
  ];

  privacyPolicy = [
    { name: 'Terms of Services', path: '/b2c/static/t&c' },
    { name: 'Privacy Policy', path: '/b2c/static/policy' },
    // { name: 'Cookie Policy', path: '/' },
    // { name: 'Cookie Settings', path: '/' },
  ];

  dealsItem = [
    { name: 'ON1 60%', path: 'assets/b2c/hotel/dealsCodeON1.png' },
    { name: 'First 50%', path: 'assets/b2c/hotel/dealsCodeFirst.png' },
    { name: 'CT Last 40%', path: 'assets/b2c/hotel/dealsCodeCTLast.png' },
    { name: 'CT Week 30%', path: 'assets/b2c/hotel/dealsCodeCTWeek.png' },
    { name: 'ON1 60%', path: 'assets/b2c/hotel/dealsCodeON1.png' },
  ];

  referItem = [
    { name: 'CHP_TIC_FRI', path: 'assets/b2c/hotel/referCHP.png' },
    { name: 'CHP_TIC_FRI', path: 'assets/b2c/hotel/referCHP.png' },
  ];

  couponItem = [
    { name: 'CHPVILLA', path: 'assets/b2c/hotel/hotel-coupon.png' },
    { name: 'CHPVILLA', path: 'assets/b2c/hotel/hotel-coupon.png' },
  ];

  viewHotel = [
    {
      name: 'Pheonix Park inn',
      location: 'Panjim',
      guest: '2',
      delPrice: '3100',
      price: '2100',
      tax: '231',
      emi: '83',
      reating: '4.3',
      reviews: '152',
      offcoupon: '20',
      imgPath: 'assets/b2c/hotel/pheonixParkInn.jpg',
    },
    {
      name: 'Pheonix Park inn',
      location: 'Panjim',
      guest: '3',
      delPrice: '3100',
      price: '2100',
      tax: '231',
      emi: '83',
      reating: '4.3',
      reviews: '152',
      offcoupon: '25',
      imgPath: 'assets/b2c/hotel/pheonixParkInn.jpg',
    },
    {
      name: 'Pheonix Park inn',
      location: 'Panjim',
      guest: '2',
      delPrice: '3100',
      price: '2100',
      tax: '231',
      emi: '83',
      reating: '4.3',
      reviews: '152',
      offcoupon: '38',
      imgPath: 'assets/b2c/hotel/pheonixParkInn.jpg',
    },
    {
      name: 'Pheonix Park inn',
      location: 'Panjim',
      guest: '3',
      delPrice: '3100',
      price: '2100',
      tax: '231',
      emi: '83',
      reating: '4.3',
      reviews: '152',
      offcoupon: '50',
      imgPath: 'assets/b2c/hotel/pheonixParkInn.jpg',
    },
    {
      name: 'Pheonix Park inn',
      location: 'Panjim',
      guest: '2',
      delPrice: '3100',
      price: '2100',
      tax: '231',
      emi: '83',
      reating: '4.3',
      reviews: '152',
      offcoupon: '80',
      imgPath: 'assets/b2c/hotel/pheonixParkInn.jpg',
    },
  ];

  hotelList = [
    {
      name: 'Radison Blu Udaipur Palace Resort & Spa',
      location: 'Fateh Sagar lake, Udaipur',
      guest: '2',
      rupees: '9250',
      value: '987',
      price: '1000',
      status: 'Recommended',
      type: 'RESORT',
      imgPath: [
        { imgPath: 'assets/b2c/hotel/pheonixParkInn.jpg' },
        { imgPath: 'assets/b2c/hotel/hotel.png' },
        { imgPath: 'assets/b2c/hotel/hotel.png' },
        { imgPath: 'assets/b2c/hotel/hotel.png' },
        { imgPath: 'assets/b2c/hotel/hotel.png' },
      ],
      ratings: '3.2',
      number: '3246',
      starRating: '3',
      deals: 'Super Deals',
      offValue: '25%',
      facility: [{ name: 'Good Food' }, { name: 'Sajjangarh biological park' }],
      amenities: [
        { name: 'Superior Room', icon: 'king_bed' },
        { name: 'Bathtub', icon: 'bathtub' },
        { name: 'Free Breakfast', icon: 'restaurant' },
        { name: 'Air Conditioner', icon: 'ac_unit' },
        { name: 'Swimming Pool', icon: 'pool' },
      ],
    },
  ];

  hotelsDetails = [
    {
      name: 'Radison Blu Udaipur Palace Resort & Spa',
      rating: '4.2/5',
      numRating: 3246,
      location: 'Fateh Sagar lake, Udaipur ',
      checkIn: '12:00 PM',
      checkOut: '11:00 AM',
      shortDesc: '1 place of interest within 1000m, 8.2km from downtown',
      hotelImage: [
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_1.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_2.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_3.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_4.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_5.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_6.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_7.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_8.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_9.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_10.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_11.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_12.jpg' },
        { imgId: '', path: 'assets/b2c/hotel/hotels/hotel_13.jpg' },
      ],
      nearBy: [
        { name: 'Airport', icon: 'flight', kilometer: '2.3km' },
        { name: 'Railway Station', icon: 'train', kilometer: '4.3km' },
      ],
      facilitiesBy: [
        { name: 'Front Desk', icon: 'key' },
        { name: 'Public Tranport', icon: 'directions_bus' },
        { name: 'Airport Pickup', icon: 'flight_takeoff' },
        { name: 'Free Parking', icon: 'local_taxi' },
      ],
      roomOption: [
        {
          name: 'Superior Room with Bathtub',
          optionsTitle: 'Choose your bed (if available)',
          roomNoTitle: 'Choose number of rooms',
          delPrice: '9250',
          price: '2100',
          tax: '987',
          emi: '250',
          bedOption: [
            { typeBed: '1 Double Bed', bedValue: true },
            { typeBed: '2 Single Bed', bedValue: false },
          ],
          inclusionsTitle: 'Inclusions',
          // inclusionsOption: [
          //   { nameInclusions: 'Free Lunch & Dinner', icon: 'restaurant_menu' },
          //   { nameInclusions: 'Non Refundable', icon: 'dangerous', color: 'red', path: '#' },
          //   { nameInclusions: 'Genius', icon: 'local_offer' },
          // ],
          amenitiesTitle: 'Room Amenities',
          amenities: [
            { name: '484 sq.ft', icon: 'check_circle' },
            { name: 'Free wifi', icon: 'wifi' },
            { name: 'No smoking', icon: 'smoke_free' },
            { name: '2 Bathrooms', icon: 'wc' },
          ],
        },
        // {
        //   name: 'Deluxe Room with Bathtub',
        //   optionsTitle: 'Choose your bed (if available)',
        //   roomNoTitle: 'Choose number of rooms',
        //   delPrice: '9250',
        //   price: '6937',
        //   tax: '987',
        //   emi: '250',
        //   bedOption: [
        //     { typeBed: '1 Double Bed', bedValue: true },
        //     { typeBed: '2 Single Bed', bedValue: false }
        //   ],
        //   inclusionsTitle: 'Inclusions',
        //   inclusionsOption: [
        //     { nameInclusions: 'Free Breakfast', icon: 'restaurant_menu' },
        //     { nameInclusions: 'Non Refundable', icon: 'dangerous', color: 'red', path: '#' },
        //     { nameInclusions: 'Genius', icon: 'local_offer' },
        //   ],
        //   amenitiesTitle : 'Room Amenities',
        //   amenities: [
        //     { name: '584 sq.ft', icon: 'check_circle'},
        //     { name: 'Free wifi', icon: 'wifi'},
        //     { name: 'No smoking', icon: 'smoke_free'},
        //     { name: '1 Bathrooms', icon: 'wc'}
        //   ]
        // }
      ],
      reviews: [
        {
          name: 'SteveHarris Ram',
          rating: '4.2',
          desc: 'Half board is the best.',
        },
        { name: 'JP Jain', rating: '4.2', desc: 'Half board is the best.' },
      ],
      policies: [
        {
          name: 'It is mandatory for guests to present valid photo identification at the time of check-in.',
        },
        {
          name: 'In case of bookings where payment is charged directly at the hotel, we need your Credit Card details to guarantee the booking. The booking confirmation is subject to successful validation of your Credit Card by the hotel. Goibibo will not charge your card however, the hotel reserves the right to charge a part or full amount before the check-in.',
        },
      ],
    },
  ];

  customerFilter = [
    { id: 1, select: false, name: '4.5+', color: 'green' },
    { id: 3, select: false, name: '4+', color: '#009b21' },
    { id: 2, select: false, name: '3+', color: '#ff690c' },
    { id: 5, select: false, name: '3.5+', color: 'orange' },
    { id: 4, select: false, name: '2.5+', color: '#d50000' },
  ];
  orders = [
    { id: 1, select: false, name: 'Hotel', lastName: 'abc' },
    { id: 2, select: false, name: 'Guest House', lastName: 'asdfgfasbc' },
    { id: 3, select: false, name: 'Homestay', lastName: 'absadfgasdc' },
    { id: 4, select: false, name: 'Villa', lastName: 'abcdsfgasd' },
    { id: 5, select: false, name: 'Resort', lastName: 'adsgabc' },
    { id: 6, select: false, name: 'Farm House', lastName: 'asds' },
    { id: 7, select: false, name: 'Apartment', lastName: 'asddgbs' },
    { id: 8, select: false, name: 'Hotel', lastName: 'asdgbds' },
  ];

  inputs = [
    { id: 1, select: false, name: 'Bar' },
    { id: 2, select: false, name: 'Pay at hotel' },
    { id: 3, select: false, name: 'zero cancellation' },
    { id: 4, select: false, name: 'Single rooms' },
    { id: 5, select: false, name: 'AC' },
    { id: 6, select: false, name: 'Wi-fi' },
    { id: 7, select: false, name: 'Parking' },
    { id: 8, select: false, name: 'Breakfast' },
  ];
  ratings: any;
  starRating: any = [
    { id: 1, select: false, name: '1 Star' },
    { id: 2, select: false, name: '2 Star' },
    { id: 3, select: false, name: '3 Star' },
    { id: 4, select: false, name: '4 Star' },
    { id: 5, select: false, name: '5 Star' },
  ];

  topDestination = [
    {
      name: 'Ayodhya',
      country: 'India',
      imgPath: 'assets/b2c/hotel/ayodhya.png',
      details: 'Starts from only Rs.8,500/-',
      explore: 'Explore',
    },
    {
      name: 'Jaipur',
      country: 'India',
      imgPath: 'assets/b2c/hotel/jaipur.png',
      details: 'Starts from only Rs.8,500/-',
      explore: 'Explore',
    },
    {
      name: 'shimla',
      country: 'India',
      imgPath: 'assets/b2c/hotel/shimla.png',
      details: 'Starts from only Rs.8,500/-',
      explore: 'Explore',
    },
    {
      name: 'manali',
      country: 'India',
      imgPath: 'assets/b2c/hotel/manali.png',
      details: 'Starts from only Rs.8,500/-',
      explore: 'Explore',
    },
    {
      name: 'Mumbai',
      country: 'India',
      imgPath: 'assets/b2c/hotel/mumbai.png',
      details: 'Starts from only Rs.8,500/-',
      explore: 'Explore',
    },
    {
      name: 'Goa',
      country: 'India',
      imgPath: 'assets/b2c/hotel/goa.png',
      details: 'Starts from only Rs.8,500/-',
      explore: 'Explore',
    },
    {
      name: 'Port Blair',
      country: 'India',
      imgPath: 'assets/b2c/hotel/A&Nisland.png',
      details: 'Starts from only Rs.8,500/-',
      explore: 'Explore',
    },
    {
      name: 'Dwarka',
      country: 'India',
      imgPath: 'assets/b2c/hotel/dwarka.jpg',
      details: 'Starts from only Rs.8,500/-',
      explore: 'Explore',
    },
  ];

  specialRequests = [
    { name: 'Late check-in', value: 'LC-IN' },
    { name: 'Large bed', value: 'LB' },
    { name: 'Early check-in', value: 'EC-IN' },
    { name: 'Smoking Room', value: 'SR' },
    { name: 'Room on a high floor', value: 'RHF' },
    { name: 'Twin Beds', value: 'TB' },
    { name: 'Airport Transfer', value: 'AT' },
  ];

  wallet = [
    { key: 'MOBK', name: 'MobiKwik', imgPath: 'assets/main/mobiKwik.png' },
    { key: 'FREEC', name: 'FreeCharge', imgPath: 'assets/main/freeCharge.png' },
    { key: 'OXIG', name: 'Oxigen', imgPath: 'assets/main/oxigenwallet.png' },
    { key: 'SBIB', name: 'SBI Buddy', imgPath: 'assets/main/sbi-Buddy.png' },
    { key: 'JIOM', name: 'JioMoney', imgPath: 'assets/main/jioMoney.png' },
  ];

  netBanking = [
    { key: 'AXIS', name: 'Axis Bank', imgPath: 'assets/main/axis.png' },
    { key: 'HDFC', name: 'HDFC Bank', imgPath: 'assets/main/hdfc.png' },
    {
      key: 'ICICI',
      name: 'ICICI Netbanking',
      imgPath: 'assets/main/ICICI.png',
    },
    {
      key: 'SBIN',
      name: 'State Bank of India',
      imgPath: 'assets/main/sbin.png',
    },
  ];

  states = [
    {
      key: 'AN',
      name: 'Andaman and Nicobar Islands',
    },
    {
      key: 'AP',
      name: 'Andhra Pradesh',
    },
    {
      key: 'AR',
      name: 'Arunachal Pradesh',
    },
    {
      key: 'AS',
      name: 'Assam',
    },
    {
      key: 'BR',
      name: 'Bihar',
    },
    {
      key: 'CG',
      name: 'Chandigarh',
    },
    {
      key: 'CH',
      name: 'Chhattisgarh',
    },
    {
      key: 'DH',
      name: 'Dadra and Nagar Haveli',
    },
    {
      key: 'DD',
      name: 'Daman and Diu',
    },
    {
      key: 'DL',
      name: 'Delhi (New Delhi)',
    },
    {
      key: 'GA',
      name: 'Goa',
    },
    {
      key: 'GJ',
      name: 'Gujarat',
    },
    {
      key: 'HR',
      name: 'Haryana',
    },
    {
      key: 'HP',
      name: 'Himachal Pradesh',
    },
    {
      key: 'JK',
      name: 'Jammu and Kashmir',
    },
    {
      key: 'JH',
      name: 'Jharkhand',
    },
    {
      key: 'KA',
      name: 'Karnataka',
    },
    {
      key: 'KL',
      name: 'Kerala',
    },
    {
      key: 'LD',
      name: 'Lakshadweep',
    },
    {
      key: 'MP',
      name: 'Madhya Pradesh',
    },
    {
      key: 'MH',
      name: 'Maharashtra',
    },
    {
      key: 'MN',
      name: 'Manipur',
    },
    {
      key: 'ML',
      name: 'Meghalaya',
    },
    {
      key: 'MZ',
      name: 'Mizoram',
    },
    {
      key: 'NL',
      name: 'Nagaland',
    },
    {
      key: 'OR',
      name: 'Odisha',
    },
    {
      key: 'PY',
      name: 'Puducherry',
    },
    {
      key: 'PB',
      name: 'Punjab',
    },
    {
      key: 'RJ',
      name: 'Rajasthan',
    },
    {
      key: 'SK',
      name: 'Sikkim',
    },
    {
      key: 'TN',
      name: 'Tamil Nadu',
    },
    {
      key: 'TS',
      name: 'Telangana',
    },
    {
      key: 'TR',
      name: 'Tripura',
    },
    {
      key: 'UK',
      name: 'Uttar Pradesh',
    },
    {
      key: 'UP',
      name: 'Uttarakhand',
    },
    {
      key: 'WB',
      name: 'West Bengal',
    },
  ];
  hotelNames = [
    { name: 'Antique Palms Resort' },
    { name: 'Blue Moon' },
    { name: 'Creek Quest' },
    { name: 'Fountain Fun' },
    { name: 'Hotel Rose' },
    { name: 'Knights Inn' },
    { name: 'Olympus Hotel' },
    { name: 'Pearl Hotel' },
    { name: 'Quality Hotels' },
    { name: 'Signature' },
    { name: 'Sunrise Cave' },
    { name: 'Vision Resort' },
  ];

  countries = [
    { name: 'Afghanistan', code: 'AF' },
    { name: 'Åland Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'AndorrA', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia', code: 'BO' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Canada', code: 'CA' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, The Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: "Cote D'Ivoire", code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'France', code: 'FR' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Germany', code: 'DE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic Of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Italy', code: 'IT' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: "Korea, Democratic People'S Republic of", code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: "Lao People'S Democratic Republic", code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'Netherlands Antilles', code: 'AN' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestinian Territory, Occupied', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Reunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'RWANDA', code: 'RW' },
    { name: 'Saint Helena', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia and Montenegro', code: 'CS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'Spain', code: 'ES' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan, Province of China', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United States', code: 'US' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' },
  ];

  guideline = [
    {
      content:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates, nisi! ',
      heading: 'Important Guidelines',
      imgLoc: '/assets/b2c/flight/caution.png',
    },
    {
      content:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates, nisi!',
      heading: 'Travel Guide',
      imgLoc: '/assets/b2c/flight/travel-guide.png',
    },
    {
      content:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates, nisi!',
      heading: 'Free Full Refund',
      imgLoc: '/assets/b2c/flight/refund.png',
    },
  ];

  offers = [
    {
      id: 0,
      flightType: 'domestic',
      value: '250$',
      promoCode: 'DOM250',
      image_bg: '/assets/b2c/flight/bg6.png',
      bank_Logo: '/assets/b2c/flight/icon1.png',
      bank_name: 'Mobikwik',
    },
    {
      id: 1,
      flightType: 'domestic',
      value: '₹ 250',
      promoCode: 'DOM250',
      image_bg: '/assets/b2c/flight/bg7.png',
      bank_Logo: '/assets/b2c/flight/icon2.png',
      bank_name: 'IDFC Bank',
    },
    {
      id: 2,
      flightType: 'domestic',
      value: '250$',
      promoCode: 'DOM250',
      image_bg: '/assets/b2c/flight/bg6.png',
      bank_Logo: '/assets/b2c/flight/icon1.png',
      bank_name: 'Mobikwik',
    },
    {
      id: 3,
      flightType: 'domestic',
      value: '₹ 250',
      promoCode: 'DOM250',
      image_bg: '/assets/b2c/flight/bg7.png',
      bank_Logo: '/assets/b2c/flight/icon1.png',
      bank_name: 'IDFC Bank',
    },
  ];

  flight = [
    {
      price: '350$ off',
      promoCode: 'DOM500',
      payment: 'Use promo code',
      imgLoc: '/assets/b2c/flight/bg1.png',
      imgLogLoc: '/assets/b2c/flight/icon1.png',
    },
    {
      price: '350$ off',
      promoCode: 'DOM500',
      payment: 'Use promo code',
      imgLoc: '/assets/b2c/flight/bg1.png',
      imgLogLoc: '/assets/b2c/flight/icon2.png',
    },
    {
      price: '350$ off',
      promoCode: 'DOM500',
      payment: 'Use promo code',
      imgLoc: '/assets/b2c/flight/bg1.png',
      imgLogLoc: '/assets/b2c/flight/icon1.png',
    },
    {
      price: '350$ off',
      promoCode: 'DOM500',
      payment: 'Use promo code',
      imgLoc: '/assets/b2c/flight/bg1.png',
      imgLogLoc: '/assets/b2c/flight/icon1.png',
    },
  ];

  hotel = [
    {
      price: '350$ off',
      promoCode: 'DOM500',
      payment: 'Use promo code',
      imgLoc: '/assets/b2c/flight/bg1.png',
      imgLogLoc: '/assets/b2c/flight/icon1.png',
    },
    {
      price: '350$ off',
      promoCode: 'DOM500',
      payment: 'Use promo code',
      imgLoc: '/assets/b2c/flight/bg1.png',
      imgLogLoc: '/assets/b2c/flight/icon2.png',
    },
    {
      price: '350$ off',
      promoCode: 'DOM500',
      payment: 'Use promo code',
      imgLoc: '/assets/b2c/flight/bg1.png',
      imgLogLoc: '/assets/b2c/flight/icon1.png',
    },
    {
      price: '350$ off',
      promoCode: 'DOM500',
      payment: 'Use promo code',
      imgLoc: '/assets/b2c/flight/bg1.png',
      imgLogLoc: '/assets/b2c/flight/icon1.png',
    },
  ];

  services = [
    {
      content:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates, nisi!',
      heading: 'Lowest Price',
      imgLoc: '/assets/b2c/flight/low_price.png',
    },
    {
      content:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates, nisi!',
      heading: 'Exciting Deals',
      imgLoc: '/assets/b2c/flight/percentage.png',
    },
    {
      content:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptates, nisi!',
      heading: '24x7 Support',
      imgLoc: '/assets/b2c/flight/customer.png',
    },
  ];
  
  destination = [
    {
      name: 'New Delhi to Mumbai',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/mumbai.png',
      SEO_URL: 'cheap-flights/new-delhi-to-mumbai'
    },
    { name: 'Chennai to Mumbai', 
      imgLoc: 'assets/b2c/flight/most_Search_Flight/mumbai2.png',
      SEO_URL: 'cheap-flights/chennai-to-mumbai' 
    },
    {
      name: 'New Delhi to Lucknow',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/lucknow.png',
      SEO_URL: 'cheap-flights/new-delhi-to-lucknow'
    },
    {
      name: 'Hyderabad to Bengaluru',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/banglore.png',
      SEO_URL: 'cheap-flights/hyderabad-to-bengaluru'
    },
    {
      name: 'Mumbai to Kolkata',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/kolkata.png',
      SEO_URL: 'cheap-flights/mumbai-to-kolkata'
    },
    {
      name: 'Mumbai to Chennai',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/chennai.png',
      SEO_URL: 'cheap-flights/mumbai-to-chennai'
    },
    // {
    //   name: 'New Delhi to Ahemdabad',
    //   imgLoc: 'assets/b2c/flight/most_Search_Flight/ahemabad.png',
    // },
    // {
    //   name: 'Mumbai to Jaipur',
    //   imgLoc: 'assets/b2c/flight/most_Search_Flight/jaipur.png',
    // },
    // {
    //   name: 'Bengaluru to New Delhi',
    //   imgLoc: 'assets/b2c/flight/most_Search_Flight/new_delhi.png',
    // },
  ];

  Topdestination = [
    {
      name: 'New Delhi to Mumbai',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/mumbai.png',
      SEO_URL: 'cheap-flights/new-delhi-to-mumbai'
    },
    { name: 'Chennai to Mumbai', 
      imgLoc: 'assets/b2c/flight/most_Search_Flight/mumbai2.png',
      SEO_URL: 'cheap-flights/chennai-to-mumbai'
    },
    {
      name: 'New Delhi to Bangkok',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/bangkok.png',
      SEO_URL: 'cheap-flights/new-delhi-to-bangkok'
    },
    {
      name: 'Mumbai to Paris',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/Paris.png',
      SEO_URL: 'cheap-flights/mumbai-to-paris'
    },

  ]

  International = [
    {
      name: 'New Delhi to Bangkok',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/bangkok.png',
      SEO_URL: 'cheap-flights/new-delhi-to-bangkok'
    },
    { name: 'Chennai to Dubai', 
      imgLoc: 'assets/b2c/flight/most_Search_Flight/dubai.png',
      SEO_URL: 'cheap-flights/chennai-to-dubai'
    },
    {
      name: 'New Delhi to Singapore',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/Singapore.png',
      SEO_URL: 'cheap-flights/new-delhi-to-singapore'
    },
    {
      name: 'Hyderabad to Denpasar Bali',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/Bali.png',
      SEO_URL: 'cheap-flights/hyderabad-to-denpasar-bali'
    },
    {
      name: 'Mumbai to New York ',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/New_york.png',
      SEO_URL: 'cheap-flights/mumbai-to-new-york'
    },
    {
      name: 'Mumbai to Paris',
      imgLoc: 'assets/b2c/flight/most_Search_Flight/Paris.png',
      SEO_URL: 'cheap-flights/mumbai-to-paris'
    },
    // {
    //   name: 'New Delhi to Ahemdabad',
    //   imgLoc: 'assets/b2c/flight/most_Search_Flight/ahemabad.png',
    // },
    // {
    //   name: 'Mumbai to Jaipur',
    //   imgLoc: 'assets/b2c/flight/most_Search_Flight/jaipur.png',
    // },
    // {
    //   name: 'Bengaluru to New Delhi',
    //   imgLoc: 'assets/b2c/flight/most_Search_Flight/new_delhi.png',
    // },
  ];

  numbers = [
    {
      name: 'Afghanistan',
      flag: '🇦🇫',
      code: 'AF',
      dial_code: '+93',
      phoneLength: 9,
    },
    {
      name: 'Åland Islands',
      flag: '🇦🇽',
      code: 'AX',
      dial_code: '+358',
      phoneLength: 6,
    },
    {
      name: 'Albania',
      flag: '🇦🇱',
      code: 'AL',
      dial_code: '+355',
      phoneLength: 7,
    },
    {
      name: 'Algeria',
      flag: '🇩🇿',
      code: 'DZ',
      dial_code: '+213',
      phoneLength: 10,
    },
    {
      name: 'American Samoa',
      flag: '🇦🇸',
      code: 'AS',
      dial_code: '+1684',
      phoneLength: 11,
    },
    {
      name: 'Andorra',
      flag: '🇦🇩',
      code: 'AD',
      dial_code: '+376',
      phoneLength: 8,
    },
    {
      name: 'Angola',
      flag: '🇦🇴',
      code: 'AO',
      dial_code: '+244',
      phoneLength: 10,
    },
    {
      name: 'Anguilla',
      flag: '🇦🇮',
      code: 'AI',
      dial_code: '+1264',
      phoneLength: 11,
    },
    {
      name: 'Antarctica',
      flag: '🇦🇶',
      code: 'AQ',
      dial_code: '+672',
      phoneLength: 4,
    },
    {
      name: 'Antigua and Barbuda',
      flag: '🇦🇬',
      code: 'AG',
      dial_code: '+1268',
      phoneLength: 11,
    },
    {
      name: 'Argentina',
      flag: '🇦🇷',
      code: 'AR',
      dial_code: '+54',
      phoneLength: 9,
    },
    {
      name: 'Armenia',
      flag: '🇦🇲',
      code: 'AM',
      dial_code: '+374',
      phoneLength: 9,
    },
    {
      name: 'Aruba',
      flag: '🇦🇼',
      code: 'AW',
      dial_code: '+297',
      phoneLength: 7,
    },
    {
      name: 'Australia',
      flag: '🇦🇺',
      code: 'AU',
      dial_code: '+61',
      phoneLength: 9,
    },
    {
      name: 'Austria',
      flag: '🇦🇹',
      code: 'AT',
      dial_code: '+43',
      phoneLength: 9,
    },
    {
      name: 'Azerbaijan',
      flag: '🇦🇿',
      code: 'AZ',
      dial_code: '+994',
      phoneLength: 10,
    },
    {
      name: 'Bahamas',
      flag: '🇧🇸',
      code: 'BS',
      dial_code: '+1242',
      phoneLength: 10,
    },
    {
      name: 'Bahrain',
      flag: '🇧🇭',
      code: 'BH',
      dial_code: '+973',
      phoneLength: 8,
    },
    {
      name: 'Bangladesh',
      flag: '🇧🇩',
      code: 'BD',
      dial_code: '+880',
      phoneLength: 10,
    },
    {
      name: 'Barbados',
      flag: '🇧🇧',
      code: 'BB',
      dial_code: '+1246',
      phoneLength: 10,
    },
    {
      name: 'Belarus',
      flag: '🇧🇾',
      code: 'BY',
      dial_code: '+375',
      phoneLength: 9,
    },
    {
      name: 'Belgium',
      flag: '🇧🇪',
      code: 'BE',
      dial_code: '+32',
      phoneLength: 9,
    },
    {
      name: 'Belize',
      flag: '🇧🇿',
      code: 'BZ',
      dial_code: '+501',
      phoneLength: 7,
    },
    {
      name: 'Benin',
      flag: '🇧🇯',
      code: 'BJ',
      dial_code: '+229',
      phoneLength: 8,
    },
    {
      name: 'Bermuda',
      flag: '🇧🇲',
      code: 'BM',
      dial_code: '+1441',
      phoneLength: 10,
    },
    {
      name: 'Bhutan',
      flag: '🇧🇹',
      code: 'BT',
      dial_code: '+975',
      phoneLength: 8,
    },
    {
      name: 'Bolivia, Plurinational State of bolivia',
      flag: '🇧🇴',
      code: 'BO',
      dial_code: '+591',
      phoneLength: 8,
    },
    {
      name: 'Bosnia and Herzegovina',
      flag: '🇧🇦',
      code: 'BA',
      dial_code: '+387',
      phoneLength: 8,
    },
    {
      name: 'Botswana',
      flag: '🇧🇼',
      code: 'BW',
      dial_code: '+267',
      phoneLength: 8,
    },
    {
      name: 'Bouvet Island',
      flag: '🇧🇻',
      code: 'BV',
      dial_code: '+47',
      phoneLength: 8,
    },
    {
      name: 'Brazil',
      flag: '🇧🇷',
      code: 'BR',
      dial_code: '+55',
      phoneLength: 11,
    },
    {
      name: 'British Indian Ocean Territory',
      flag: '🇮🇴',
      code: 'IO',
      dial_code: '+246',
      phoneLength: 7,
    },
    {
      name: 'Brunei Darussalam',
      flag: '🇧🇳',
      code: 'BN',
      dial_code: '+673',
      phoneLength: 7,
    },
    {
      name: 'Bulgaria',
      flag: '🇧🇬',
      code: 'BG',
      dial_code: '+359',
      phoneLength: 9,
    },
    {
      name: 'Burkina Faso',
      flag: '🇧🇫',
      code: 'BF',
      dial_code: '+226',
      phoneLength: 8,
    },
    {
      name: 'Burundi',
      flag: '🇧🇮',
      code: 'BI',
      dial_code: '+257',
      phoneLength: 8,
    },
    {
      name: 'Cambodia',
      flag: '🇰🇭',
      code: 'KH',
      dial_code: '+855',
      phoneLength: 9,
    },
    {
      name: 'Cameroon',
      flag: '🇨🇲',
      code: 'CM',
      dial_code: '+237',
      phoneLength: 9,
    },
    {
      name: 'Canada',
      flag: '🇨🇦',
      code: 'CA',
      dial_code: '+1',
      phoneLength: 10,
    },
    {
      name: 'Cape Verde',
      flag: '🇨🇻',
      code: 'CV',
      dial_code: '+238',
      phoneLength: 7,
    },
    {
      name: 'Cayman Islands',
      flag: '🇰🇾',
      code: 'KY',
      dial_code: '+345',
      phoneLength: 7,
    },
    {
      name: 'Central African Republic',
      flag: '🇨🇫',
      code: 'CF',
      dial_code: '+236',
      phoneLength: 8,
    },
    {
      name: 'Chad',
      flag: '🇹🇩',
      code: 'TD',
      dial_code: '+235',
      phoneLength: 8,
    },
    {
      name: 'Chile',
      flag: '🇨🇱',
      code: 'CL',
      dial_code: '+56',
      phoneLength: 9,
    },
    {
      name: 'China',
      flag: '🇨🇳',
      code: 'CN',
      dial_code: '+86',
      phoneLength: 11,
    },
    {
      name: 'Christmas Island',
      flag: '🇨🇽',
      code: 'CX',
      dial_code: '+61',
      phoneLength: 9,
    },
    {
      name: 'Cocos (Keeling) Islands',
      flag: '🇨🇨',
      code: 'CC',
      dial_code: '+61',
      phoneLength: 9,
    },
    {
      name: 'Colombia',
      flag: '🇨🇴',
      code: 'CO',
      dial_code: '+57',
      phoneLength: 10,
    },
    {
      name: 'Comoros',
      flag: '🇰🇲',
      code: 'KM',
      dial_code: '+269',
      phoneLength: 7,
    },
    {
      name: 'Congo',
      flag: '🇨🇬',
      code: 'CG',
      dial_code: '+242',
      phoneLength: 9,
    },
    {
      name: 'Congo, The Democratic Republic of the Congo',
      flag: '🇨🇩',
      code: 'CD',
      dial_code: '+243',
      phoneLength: 9,
    },
    {
      name: 'Cook Islands',
      flag: '🇨🇰',
      code: 'CK',
      dial_code: '+682',
      phoneLength: 7,
    },
    {
      name: 'Costa Rica',
      flag: '🇨🇷',
      code: 'CR',
      dial_code: '+506',
      phoneLength: 8,
    },
    {
      name: "Cote d'Ivoire",
      flag: '🇨🇮',
      code: 'CI',
      dial_code: '+225',
      phoneLength: 10,
    },
    {
      name: 'Croatia',
      flag: '🇭🇷',
      code: 'HR',
      dial_code: '+385',
      phoneLength: 9,
    },
    {
      name: 'Cuba',
      flag: '🇨🇺',
      code: 'CU',
      dial_code: '+53',
      phoneLength: 8,
    },
    {
      name: 'Cyprus',
      flag: '🇨🇾',
      code: 'CY',
      dial_code: '+357',
      phoneLength: 9,
    },
    {
      name: 'Czech Republic',
      flag: '🇨🇿',
      code: 'CZ',
      dial_code: '+420',
      phoneLength: 9,
    },
    {
      name: 'Denmark',
      flag: '🇩🇰',
      code: 'DK',
      dial_code: '+45',
      phoneLength: 8,
    },
    {
      name: 'Djibouti',
      flag: '🇩🇯',
      code: 'DJ',
      dial_code: '+253',
      phoneLength: 8,
    },
    {
      name: 'Dominica',
      flag: '🇩🇲',
      code: 'DM',
      dial_code: '+1767',
      phoneLength: 7,
    },
    {
      name: 'Dominican Republic',
      flag: '🇩🇴',
      code: 'DO',
      dial_code: '+1849',
      phoneLength: 10,
    },
    {
      name: 'Ecuador',
      flag: '🇪🇨',
      code: 'EC',
      dial_code: '+593',
      phoneLength: 9,
    },
    {
      name: 'Egypt',
      flag: '🇪🇬',
      code: 'EG',
      dial_code: '+20',
      phoneLength: 10,
    },
    {
      name: 'El Salvador',
      flag: '🇸🇻',
      code: 'SV',
      dial_code: '+503',
      phoneLength: 8,
    },
    {
      name: 'Equatorial Guinea',
      flag: '🇬🇶',
      code: 'GQ',
      dial_code: '+240',
      phoneLength: 7,
    },
    {
      name: 'Eritrea',
      flag: '🇪🇷',
      code: 'ER',
      dial_code: '+291',
      phoneLength: 7,
    },
    {
      name: 'Estonia',
      flag: '🇪🇪',
      code: 'EE',
      dial_code: '+372',
      phoneLength: 7,
    },
    {
      name: 'Ethiopia',
      flag: '🇪🇹',
      code: 'ET',
      dial_code: '+251',
      phoneLength: 9,
    },
    {
      name: 'Falkland Islands (Malvinas)',
      flag: '🇫🇰',
      code: 'FK',
      dial_code: '+500',
      phoneLength: 5,
    },
    {
      name: 'Faroe Islands',
      flag: '🇫🇴',
      code: 'FO',
      dial_code: '+298',
      phoneLength: 6,
    },
    {
      name: 'Fiji',
      flag: '🇫🇯',
      code: 'FJ',
      dial_code: '+679',
      phoneLength: 7,
    },
    {
      name: 'Finland',
      flag: '🇫🇮',
      code: 'FI',
      dial_code: '+358',
      phoneLength: 9,
    },
    {
      name: 'France',
      flag: '🇫🇷',
      code: 'FR',
      dial_code: '+33',
      phoneLength: 9,
    },
    {
      name: 'French Guiana',
      flag: '🇬🇫',
      code: 'GF',
      dial_code: '+594',
      phoneLength: 9,
    },
    {
      name: 'French Polynesia',
      flag: '🇵🇫',
      code: 'PF',
      dial_code: '+689',
      phoneLength: 6,
    },
    {
      name: 'French Southern Territories',
      flag: '🇹🇫',
      code: 'TF',
      dial_code: '+262',
      phoneLength: 9,
    },
    {
      name: 'Gabon',
      flag: '🇬🇦',
      code: 'GA',
      dial_code: '+241',
      phoneLength: 7,
    },
    {
      name: 'Gambia',
      flag: '🇬🇲',
      code: 'GM',
      dial_code: '+220',
      phoneLength: 7,
    },
    {
      name: 'Georgia',
      flag: '🇬🇪',
      code: 'GE',
      dial_code: '+995',
      phoneLength: 9,
    },
    {
      name: 'Germany',
      flag: '🇩🇪',
      code: 'DE',
      dial_code: '+49',
      phoneLength: 11,
    },
    {
      name: 'Ghana',
      flag: '🇬🇭',
      code: 'GH',
      dial_code: '+233',
      phoneLength: 9,
    },
    {
      name: 'Gibraltar',
      flag: '🇬🇮',
      code: 'GI',
      dial_code: '+350',
      phoneLength: 8,
    },
    {
      name: 'Greece',
      flag: '🇬🇷',
      code: 'GR',
      dial_code: '+30',
      phoneLength: 10,
    },
    {
      name: 'Greenland',
      flag: '🇬🇱',
      code: 'GL',
      dial_code: '+299',
      phoneLength: 6,
    },
    {
      name: 'Grenada',
      flag: '🇬🇩',
      code: 'GD',
      dial_code: '+1473',
      phoneLength: 7,
    },
    {
      name: 'Guadeloupe',
      flag: '🇬🇵',
      code: 'GP',
      dial_code: '+590',
      phoneLength: 9,
    },
    {
      name: 'Guam',
      flag: '🇬🇺',
      code: 'GU',
      dial_code: '+1671',
      phoneLength: 7,
    },
    {
      name: 'Guatemala',
      flag: '🇬🇹',
      code: 'GT',
      dial_code: '+502',
      phoneLength: 8,
    },
    {
      name: 'Guernsey',
      flag: '🇬🇬',
      code: 'GG',
      dial_code: '+44',
      phoneLength: 10,
    },
    {
      name: 'Guinea',
      flag: '🇬🇳',
      code: 'GN',
      dial_code: '+224',
      phoneLength: 8,
    },
    {
      name: 'Guinea-Bissau',
      flag: '🇬🇼',
      code: 'GW',
      dial_code: '+245',
      phoneLength: 7,
    },
    {
      name: 'Guyana',
      flag: '🇬🇾',
      code: 'GY',
      dial_code: '+592',
      phoneLength: 7,
    },
    {
      name: 'Haiti',
      flag: '🇭🇹',
      code: 'HT',
      dial_code: '+509',
      phoneLength: 8,
    },
    {
      name: 'Heard Island and Mcdonald Islands',
      flag: '🇭🇲',
      code: 'HM',
      dial_code: '+672',
      phoneLength: 7,
    },
    {
      name: 'Holy See (Vatican City State)',
      flag: '🇻🇦',
      code: 'VA',
      dial_code: '+379',
      phoneLength: 10,
    },
    {
      name: 'Honduras',
      flag: '🇭🇳',
      code: 'HN',
      dial_code: '+504',
      phoneLength: 8,
    },
    {
      name: 'Hong Kong',
      flag: '🇭🇰',
      code: 'HK',
      dial_code: '+852',
      phoneLength: 8,
    },
    {
      name: 'Hungary',
      flag: '🇭🇺',
      code: 'HU',
      dial_code: '+36',
      phoneLength: 9,
    },
    {
      name: 'Iceland',
      flag: '🇮🇸',
      code: 'IS',
      dial_code: '+354',
      phoneLength: 7,
    },
    {
      name: 'India',
      flag: '🇮🇳',
      code: 'IN',
      dial_code: '+91',
      phoneLength: 10,
    },
    {
      name: 'Indonesia',
      flag: '🇮🇩',
      code: 'ID',
      dial_code: '+62',
      phoneLength: 9,
    },
    {
      name: 'Iran, Islamic Republic of Persian Gulf',
      flag: '🇮🇷',
      code: 'IR',
      dial_code: '+98',
      phoneLength: 10,
    },
    {
      name: 'Iraq',
      flag: '🇮🇶',
      code: 'IQ',
      dial_code: '+964',
      phoneLength: 10,
    },
    {
      name: 'Ireland',
      flag: '🇮🇪',
      code: 'IE',
      dial_code: '+353',
      phoneLength: 9,
    },
    {
      name: 'Isle of Man',
      flag: '🇮🇲',
      code: 'IM',
      dial_code: '+44',
      phoneLength: 10,
    },
    {
      name: 'Israel',
      flag: '🇮🇱',
      code: 'IL',
      dial_code: '+972',
      phoneLength: 9,
    },
    {
      name: 'Italy',
      flag: '🇮🇹',
      code: 'IT',
      dial_code: '+39',
      phoneLength: 10,
    },
    {
      name: 'Jamaica',
      flag: '🇯🇲',
      code: 'JM',
      dial_code: '+1876',
      phoneLength: 7,
    },
    {
      name: 'Japan',
      flag: '🇯🇵',
      code: 'JP',
      dial_code: '+81',
      phoneLength: 10,
    },
    {
      name: 'Jersey',
      flag: '🇯🇪',
      code: 'JE',
      dial_code: '+44',
      phoneLength: 10,
    },
    {
      name: 'Jordan',
      flag: '🇯🇴',
      code: 'JO',
      dial_code: '+962',
      phoneLength: 9,
    },
    {
      name: 'Kazakhstan',
      flag: '🇰🇿',
      code: 'KZ',
      dial_code: '+7',
      phoneLength: 10,
    },
    {
      name: 'Kenya',
      flag: '🇰🇪',
      code: 'KE',
      dial_code: '+254',
      phoneLength: 9,
    },
    {
      name: 'Kiribati',
      flag: '🇰🇮',
      code: 'KI',
      dial_code: '+686',
      phoneLength: 5,
    },
    {
      name: "Korea, Democratic People's Republic of Korea",
      flag: '🇰🇵',
      code: 'KP',
      dial_code: '+850',
      phoneLength: 9,
    },
    {
      name: 'Korea, Republic of South Korea',
      flag: '🇰🇷',
      code: 'KR',
      dial_code: '+82',
      phoneLength: 9,
    },
    {
      name: 'Kosovo',
      flag: '🇽🇰',
      code: 'XK',
      dial_code: '+383',
      phoneLength: 8,
    },
    {
      name: 'Kuwait',
      flag: '🇰🇼',
      code: 'KW',
      dial_code: '+965',
      phoneLength: 8,
    },
    {
      name: 'Kyrgyzstan',
      flag: '🇰🇬',
      code: 'KG',
      dial_code: '+996',
      phoneLength: 9,
    },
    {
      name: 'Laos',
      flag: '🇱🇦',
      code: 'LA',
      dial_code: '+856',
      phoneLength: 8,
    },
    {
      name: 'Latvia',
      flag: '🇱🇻',
      code: 'LV',
      dial_code: '+371',
      phoneLength: 8,
    },
    {
      name: 'Lebanon',
      flag: '🇱🇧',
      code: 'LB',
      dial_code: '+961',
      phoneLength: 7,
    },
    {
      name: 'Lesotho',
      flag: '🇱🇸',
      code: 'LS',
      dial_code: '+266',
      phoneLength: 8,
    },
    {
      name: 'Liberia',
      flag: '🇱🇷',
      code: 'LR',
      dial_code: '+231',
      phoneLength: 7,
    },
    {
      name: 'Libyan Arab Jamahiriya',
      flag: '🇱🇾',
      code: 'LY',
      dial_code: '+218',
      phoneLength: 9,
    },
    {
      name: 'Liechtenstein',
      flag: '🇱🇮',
      code: 'LI',
      dial_code: '+423',
      phoneLength: 7,
    },
    {
      name: 'Lithuania',
      flag: '🇱🇹',
      code: 'LT',
      dial_code: '+370',
      phoneLength: 8,
    },
    {
      name: 'Luxembourg',
      flag: '🇱🇺',
      code: 'LU',
      dial_code: '+352',
      phoneLength: 9,
    },
    {
      name: 'Macao',
      flag: '🇲🇴',
      code: 'MO',
      dial_code: '+853',
      phoneLength: 8,
    },
    {
      name: 'Macedonia',
      flag: '🇲🇰',
      code: 'MK',
      dial_code: '+389',
      phoneLength: 8,
    },
    {
      name: 'Madagascar',
      flag: '🇲🇬',
      code: 'MG',
      dial_code: '+261',
      phoneLength: 9,
    },
    {
      name: 'Malawi',
      flag: '🇲🇼',
      code: 'MW',
      dial_code: '+265',
      phoneLength: 9,
    },
    {
      name: 'Malaysia',
      flag: '🇲🇾',
      code: 'MY',
      dial_code: '+60',
      phoneLength: 9,
    },
    {
      name: 'Maldives',
      flag: '🇲🇻',
      code: 'MV',
      dial_code: '+960',
      phoneLength: 7,
    },
    {
      name: 'Mali',
      flag: '🇲🇱',
      code: 'ML',
      dial_code: '+223',
      phoneLength: 8,
    },
    {
      name: 'Malta',
      flag: '🇲🇹',
      code: 'MT',
      dial_code: '+356',
      phoneLength: 8,
    },
    {
      name: 'Marshall Islands',
      flag: '🇲🇭',
      code: 'MH',
      dial_code: '+692',
      phoneLength: 7,
    },
    {
      name: 'Martinique',
      flag: '🇲🇶',
      code: 'MQ',
      dial_code: '+596',
      phoneLength: 9,
    },
    {
      name: 'Mauritania',
      flag: '🇲🇷',
      code: 'MR',
      dial_code: '+222',
      phoneLength: 8,
    },
    {
      name: 'Mauritius',
      flag: '🇲🇺',
      code: 'MU',
      dial_code: '+230',
      phoneLength: 7,
    },
    {
      name: 'Mayotte',
      flag: '🇾🇹',
      code: 'YT',
      dial_code: '+262',
      phoneLength: 9,
    },
    {
      name: 'Mexico',
      flag: '🇲🇽',
      code: 'MX',
      dial_code: '+52',
      phoneLength: 10,
    },
    {
      name: 'Micronesia, Federated States of Micronesia',
      flag: '🇫🇲',
      code: 'FM',
      dial_code: '+691',
      phoneLength: 7,
    },
    {
      name: 'Moldova',
      flag: '🇲🇩',
      code: 'MD',
      dial_code: '+373',
      phoneLength: 8,
    },
    {
      name: 'Monaco',
      flag: '🇲🇨',
      code: 'MC',
      dial_code: '+377',
      phoneLength: 8,
    },
    {
      name: 'Mongolia',
      flag: '🇲🇳',
      code: 'MN',
      dial_code: '+976',
      phoneLength: 8,
    },
    {
      name: 'Montenegro',
      flag: '🇲🇪',
      code: 'ME',
      dial_code: '+382',
      phoneLength: 8,
    },
    {
      name: 'Montserrat',
      flag: '🇲🇸',
      code: 'MS',
      dial_code: '+1664',
      phoneLength: 7,
    },
    {
      name: 'Morocco',
      flag: '🇲🇦',
      code: 'MA',
      dial_code: '+212',
      phoneLength: 9,
    },
    {
      name: 'Mozambique',
      flag: '🇲🇿',
      code: 'MZ',
      dial_code: '+258',
      phoneLength: 9,
    },
    {
      name: 'Myanmar',
      flag: '🇲🇲',
      code: 'MM',
      dial_code: '+95',
      phoneLength: 9,
    },
    {
      name: 'Namibia',
      flag: '🇳🇦',
      code: 'NA',
      dial_code: '+264',
      phoneLength: 10,
    },
    {
      name: 'Nauru',
      flag: '🇳🇷',
      code: 'NR',
      dial_code: '+674',
      phoneLength: 7,
    },
    {
      name: 'Nepal',
      flag: '🇳🇵',
      code: 'NP',
      dial_code: '+977',
      phoneLength: 10,
    },
    {
      name: 'Netherlands',
      flag: '🇳🇱',
      code: 'NL',
      dial_code: '+31',
      phoneLength: 9,
    },
    {
      name: 'Netherlands Antilles',
      flag: '',
      code: 'AN',
      dial_code: '+599',
      phoneLength: 7,
    },
    {
      name: 'New Caledonia',
      flag: '🇳🇨',
      code: 'NC',
      dial_code: '+687',
      phoneLength: 6,
    },
    {
      name: 'New Zealand',
      flag: '🇳🇿',
      code: 'NZ',
      dial_code: '+64',
      phoneLength: 8,
    },
    {
      name: 'Nicaragua',
      flag: '🇳🇮',
      code: 'NI',
      dial_code: '+505',
      phoneLength: 8,
    },
    {
      name: 'Niger',
      flag: '🇳🇪',
      code: 'NE',
      dial_code: '+227',
      phoneLength: 8,
    },
    {
      name: 'Nigeria',
      flag: '🇳🇬',
      code: 'NG',
      dial_code: '+234',
      phoneLength: 10,
    },
    {
      name: 'Niue',
      flag: '🇳🇺',
      code: 'NU',
      dial_code: '+683',
      phoneLength: 4,
    },
    {
      name: 'Norfolk Island',
      flag: '🇳🇫',
      code: 'NF',
      dial_code: '+672',
      phoneLength: 5,
    },
    {
      name: 'Northern Mariana Islands',
      flag: '🇲🇵',
      code: 'MP',
      dial_code: '+1670',
      phoneLength: 7,
    },
    {
      name: 'Norway',
      flag: '🇳🇴',
      code: 'NO',
      dial_code: '+47',
      phoneLength: 8,
    },
    {
      name: 'Oman',
      flag: '🇴🇲',
      code: 'OM',
      dial_code: '+968',
      phoneLength: 8,
    },
    {
      name: 'Pakistan',
      flag: '🇵🇰',
      code: 'PK',
      dial_code: '+92',
      phoneLength: 10,
    },
    {
      name: 'Palau',
      flag: '🇵🇼',
      code: 'PW',
      dial_code: '+680',
      phoneLength: 7,
    },
    {
      name: 'Palestinian Territory, Occupied',
      flag: '🇵🇸',
      code: 'PS',
      dial_code: '+970',
      phoneLength: 8,
    },
    {
      name: 'Panama',
      flag: '🇵🇦',
      code: 'PA',
      dial_code: '+507',
      phoneLength: 8,
    },
    {
      name: 'Papua New Guinea',
      flag: '🇵🇬',
      code: 'PG',
      dial_code: '+675',
      phoneLength: 7,
    },
    {
      name: 'Paraguay',
      flag: '🇵🇾',
      code: 'PY',
      dial_code: '+595',
      phoneLength: 9,
    },
    {
      name: 'Peru',
      flag: '🇵🇪',
      code: 'PE',
      dial_code: '+51',
      phoneLength: 9,
    },
    {
      name: 'Philippines',
      flag: '🇵🇭',
      code: 'PH',
      dial_code: '+63',
      phoneLength: 10,
    },
    {
      name: 'Pitcairn',
      flag: '🇵🇳',
      code: 'PN',
      dial_code: '+64',
      phoneLength: 7,
    },
    {
      name: 'Poland',
      flag: '🇵🇱',
      code: 'PL',
      dial_code: '+48',
      phoneLength: 9,
    },
    {
      name: 'Portugal',
      flag: '🇵🇹',
      code: 'PT',
      dial_code: '+351',
      phoneLength: 9,
    },
    {
      name: 'Puerto Rico',
      flag: '🇵🇷',
      code: 'PR',
      dial_code: '+1939',
      phoneLength: 10,
    },
    {
      name: 'Qatar',
      flag: '🇶🇦',
      code: 'QA',
      dial_code: '+974',
      phoneLength: 8,
    },
    {
      name: 'Romania',
      flag: '🇷🇴',
      code: 'RO',
      dial_code: '+40',
      phoneLength: 9,
    },
    {
      name: 'Russia',
      flag: '🇷🇺',
      code: 'RU',
      dial_code: '+7',
      phoneLength: 10,
    },
    {
      name: 'Rwanda',
      flag: '🇷🇼',
      code: 'RW',
      dial_code: '+250',
      phoneLength: 9,
    },
    {
      name: 'Reunion',
      flag: '🇷🇪',
      code: 'RE',
      dial_code: '+262',
      phoneLength: 9,
    },
    {
      name: 'Saint Barthelemy',
      flag: '🇧🇱',
      code: 'BL',
      dial_code: '+590',
      phoneLength: 9,
    },
    {
      name: 'Saint Helena, Ascension and Tristan Da Cunha',
      flag: '🇸🇭',
      code: 'SH',
      dial_code: '+290',
      phoneLength: 4,
    },
    {
      name: 'Saint Kitts and Nevis',
      flag: '🇰🇳',
      code: 'KN',
      dial_code: '+1869',
      phoneLength: 7,
    },
    {
      name: 'Saint Lucia',
      flag: '🇱🇨',
      code: 'LC',
      dial_code: '+1758',
      phoneLength: 7,
    },
    {
      name: 'Saint Martin',
      flag: '🇲🇫',
      code: 'MF',
      dial_code: '+590',
      phoneLength: 9,
    },
    {
      name: 'Saint Pierre and Miquelon',
      flag: '🇵🇲',
      code: 'PM',
      dial_code: '+508',
      phoneLength: 6,
    },
    {
      name: 'Saint Vincent and the Grenadines',
      flag: '🇻🇨',
      code: 'VC',
      dial_code: '+1784',
      phoneLength: 10,
    },
    {
      name: 'Samoa',
      flag: '🇼🇸',
      code: 'WS',
      dial_code: '+685',
      phoneLength: 7,
    },
    {
      name: 'San Marino',
      flag: '🇸🇲',
      code: 'SM',
      dial_code: '+378',
      phoneLength: 8,
    },
    {
      name: 'Sao Tome and Principe',
      flag: '🇸🇹',
      code: 'ST',
      dial_code: '+239',
      phoneLength: 7,
    },
    {
      name: 'Saudi Arabia',
      flag: '🇸🇦',
      code: 'SA',
      dial_code: '+966',
      phoneLength: 9,
    },
    {
      name: 'Senegal',
      flag: '🇸🇳',
      code: 'SN',
      dial_code: '+221',
      phoneLength: 9,
    },
    {
      name: 'Serbia',
      flag: '🇷🇸',
      code: 'RS',
      dial_code: '+381',
      phoneLength: 8,
    },
    {
      name: 'Seychelles',
      flag: '🇸🇨',
      code: 'SC',
      dial_code: '+248',
      phoneLength: 7,
    },
    {
      name: 'Sierra Leone',
      flag: '🇸🇱',
      code: 'SL',
      dial_code: '+232',
      phoneLength: 8,
    },
    {
      name: 'Singapore',
      flag: '🇸🇬',
      code: 'SG',
      dial_code: '+65',
      phoneLength: 8,
    },
    {
      name: 'Slovakia',
      flag: '🇸🇰',
      code: 'SK',
      dial_code: '+421',
      phoneLength: 9,
    },
    {
      name: 'Slovenia',
      flag: '🇸🇮',
      code: 'SI',
      dial_code: '+386',
      phoneLength: 8,
    },
    {
      name: 'Solomon Islands',
      flag: '🇸🇧',
      code: 'SB',
      dial_code: '+677',
      phoneLength: 7,
    },
    {
      name: 'Somalia',
      flag: '🇸🇴',
      code: 'SO',
      dial_code: '+252',
      phoneLength: 8,
    },
    {
      name: 'South Africa',
      flag: '🇿🇦',
      code: 'ZA',
      dial_code: '+27',
      phoneLength: 9,
    },
    {
      name: 'South Sudan',
      flag: '🇸🇸',
      code: 'SS',
      dial_code: '+211',
      phoneLength: 9,
    },
    {
      name: 'South Georgia and the South Sandwich Islands',
      flag: '🇬🇸',
      code: 'GS',
      dial_code: '+500',
      phoneLength: 4,
    },
    {
      name: 'Spain',
      flag: '🇪🇸',
      code: 'ES',
      dial_code: '+34',
      phoneLength: 9,
    },
    {
      name: 'Sri Lanka',
      flag: '🇱🇰',
      code: 'LK',
      dial_code: '+94',
      phoneLength: 9,
    },
    {
      name: 'Sudan',
      flag: '🇸🇩',
      code: 'SD',
      dial_code: '+249',
      phoneLength: 9,
    },
    {
      name: 'Suriname',
      flag: '🇸🇷',
      code: 'SR',
      dial_code: '+597',
      phoneLength: 7,
    },
    {
      name: 'Svalbard and Jan Mayen',
      flag: '🇸🇯',
      code: 'SJ',
      dial_code: '+47',
      phoneLength: 8,
    },
    {
      name: 'Eswatini',
      flag: '🇸🇿',
      code: 'SZ',
      dial_code: '+268',
      phoneLength: 8,
    },
    {
      name: 'Sweden',
      flag: '🇸🇪',
      code: 'SE',
      dial_code: '+46',
      phoneLength: 9,
    },
    {
      name: 'Switzerland',
      flag: '🇨🇭',
      code: 'CH',
      dial_code: '+41',
      phoneLength: 9,
    },
    {
      name: 'Syrian Arab Republic',
      flag: '🇸🇾',
      code: 'SY',
      dial_code: '+963',
      phoneLength: 9,
    },
    {
      name: 'Taiwan',
      flag: '🇹🇼',
      code: 'TW',
      dial_code: '+886',
      phoneLength: 9,
    },
    {
      name: 'Tajikistan',
      flag: '🇹🇯',
      code: 'TJ',
      dial_code: '+992',
      phoneLength: 9,
    },
    {
      name: 'Tanzania, United Republic of Tanzania',
      flag: '🇹🇿',
      code: 'TZ',
      dial_code: '+255',
      phoneLength: 9,
    },
    {
      name: 'Thailand',
      flag: '🇹🇭',
      code: 'TH',
      dial_code: '+66',
      phoneLength: 9,
    },
    {
      name: 'Timor-Leste',
      flag: '🇹🇱',
      code: 'TL',
      dial_code: '+670',
      phoneLength: 7,
    },
    {
      name: 'Togo',
      flag: '🇹🇬',
      code: 'TG',
      dial_code: '+228',
      phoneLength: 8,
    },
    {
      name: 'Tokelau',
      flag: '🇹🇰',
      code: 'TK',
      dial_code: '+690',
      phoneLength: 4,
    },
    {
      name: 'Tonga',
      flag: '🇹🇴',
      code: 'TO',
      dial_code: '+676',
      phoneLength: 5,
    },
    {
      name: 'Trinidad and Tobago',
      flag: '🇹🇹',
      code: 'TT',
      dial_code: '+1868',
      phoneLength: 7,
    },
    {
      name: 'Tunisia',
      flag: '🇹🇳',
      code: 'TN',
      dial_code: '+216',
      phoneLength: 8,
    },
    {
      name: 'Turkey',
      flag: '🇹🇷',
      code: 'TR',
      dial_code: '+90',
      phoneLength: 10,
    },
    {
      name: 'Turkmenistan',
      flag: '🇹🇲',
      code: 'TM',
      dial_code: '+993',
      phoneLength: 8,
    },
    {
      name: 'Turks and Caicos Islands',
      flag: '🇹🇨',
      code: 'TC',
      dial_code: '+1649',
      phoneLength: 7,
    },
    {
      name: 'Tuvalu',
      flag: '🇹🇻',
      code: 'TV',
      dial_code: '+688',
      phoneLength: 5,
    },
    {
      name: 'Uganda',
      flag: '🇺🇬',
      code: 'UG',
      dial_code: '+256',
      phoneLength: 9,
    },
    {
      name: 'Ukraine',
      flag: '🇺🇦',
      code: 'UA',
      dial_code: '+380',
      phoneLength: 9,
    },
    {
      name: 'United Arab Emirates',
      flag: '🇦🇪',
      code: 'AE',
      dial_code: '+971',
      phoneLength: 9,
    },
    {
      name: 'United Kingdom',
      flag: '🇬🇧',
      code: 'GB',
      dial_code: '+44',
      phoneLength: 10,
    },
    {
      name: 'United States',
      flag: '🇺🇸',
      code: 'US',
      dial_code: '+1',
      phoneLength: 10,
    },
    {
      name: 'Uruguay',
      flag: '🇺🇾',
      code: 'UY',
      dial_code: '+598',
      phoneLength: 8,
    },
    {
      name: 'Uzbekistan',
      flag: '🇺🇿',
      code: 'UZ',
      dial_code: '+998',
      phoneLength: 9,
    },
    {
      name: 'Vanuatu',
      flag: '🇻🇺',
      code: 'VU',
      dial_code: '+678',
      phoneLength: 7,
    },
    {
      name: 'Venezuela, Bolivarian Republic of Venezuela',
      flag: '🇻🇪',
      code: 'VE',
      dial_code: '+58',
      phoneLength: 11,
    },
    {
      name: 'Vietnam',
      flag: '🇻🇳',
      code: 'VN',
      dial_code: '+84',
      phoneLength: 10,
    },
    {
      name: 'Virgin Islands, British',
      flag: '🇻🇬',
      code: 'VG',
      dial_code: '+1284',
      phoneLength: 10,
    },
    {
      name: 'Virgin Islands, U.S.',
      flag: '🇻🇮',
      code: 'VI',
      dial_code: '+1340',
      phoneLength: 10,
    },
    {
      name: 'Wallis and Futuna',
      flag: '🇼🇫',
      code: 'WF',
      dial_code: '+681',
      phoneLength: 6,
    },
    {
      name: 'Yemen',
      flag: '🇾🇪',
      code: 'YE',
      dial_code: '+967',
      phoneLength: 9,
    },
    {
      name: 'Zambia',
      flag: '🇿🇲',
      code: 'ZM',
      dial_code: '+260',
      phoneLength: 9,
    },
    {
      name: 'Zimbabwe',
      flag: '🇿🇼',
      code: 'ZW',
      dial_code: '+263',
      phoneLength: 9,
    },
  ];

  age = [
    { age: '1' },
    { age: '2' },
    { age: '3' },
    { age: '4' },
    { age: '5' },
    { age: '6' },
    { age: '7' },
    { age: '8' },
    { age: '9' },
    { age: '10' },
    { age: '11' },
    { age: '12' },
  ];
  items = [{ rating: 2 }];

  flightLogo = [{ imgPath: 'assets/b2c/flight/indigo.png' }];

  travellList = [ ];

  traveldetails = [];
  traveldata = [];

  // air = [
  //   { id:1, select:false, name: 'Indigo', },
  //   { id:2, select:false, name: 'Spice.jet', },
  //   { id:3, select:false, name: 'AirAsia', },
  //   { id:4, select:false, name: 'Air India', },
  //   { id:5, select:false, name: 'Vistara', },
  //   { id:6, select:false, name: 'GoAir', },
  // ]
  air = [
    { name: 'Indigo' },
    { name: 'Air India' },
    { name: 'Vistara' },
    { name: 'GoAir' },
    { name: 'Spice.jet' },
    { name: 'Air Asia' },
  ];

  specialRequest = [
    { name: 'Late check-in', code: 'LCIN' },
    { name: 'Large bed', code: 'LAGB' },
    { name: 'Early check-in', code: 'ECIN' },
    { name: 'Smoking room', code: 'SOMR' },
    { name: 'Room on a high floor', code: 'ROHF' },
    { name: 'Twin beds', code: 'TWIB' },
    { name: 'Airport transfer', code: 'AIRT' },
  ];
  gstInfo = [];

  passanger = [
    { name: 'Sunil', mobile: '9717097238', email: 'sunil@belair.in' },
    {
      name: 'Mohit Sharma',
      mobile: '9715472149',
      email: 'sharma_mohit65@belair.in',
    },
    {
      name: 'Ankur Aggarwal',
      mobile: '9858632489',
      email: 'apna_ankur45@belair.in',
    },
    {
      name: 'Nidhi Maheshwari',
      mobile: '9999247964',
      email: 'mahesh_nidhi89@belair.in',
    },
  ];

  roomOptions = [
    { name: 'Room Options' },
    { name: 'Hotel Description' },
    { name: 'Hotel Policies' },
    { name: 'Facilities' },
  ];

  trip_selected = [
    { name: 'One Way', value: 0 },
    { name: 'Round Way', value: 1 },
    // { name: 'Multi City', value: 2 },
  ];

  flight_class = [
    { name: 'Economy', value: '1' },
    { name: 'Premium Economy', value: '2' },
    { name: 'Business', value: '3' },
    { name: 'First', value: '4' },
  ];

  flight_airport = [
    {
      id: 1236,
      city_code: 'DEL',
      city_name: 'New Delhi',
      airport_type: 2,
      airport_name: 'Delhi Indira Gandhi Intl',
      airport_code: 'DEL',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 946,
      city_code: 'BOM',
      city_name: 'Mumbai',
      airport_type: 2,
      airport_name: 'Chhatrapati Shivaji',
      airport_code: 'BOM',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 2463,
      city_code: 'BLR',
      city_name: 'Bengaluru',
      airport_type: 2,
      airport_name: 'Kempegowda Intl Arpt',
      airport_code: 'BLR',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 1169,
      city_code: 'GOI',
      city_name: 'Goa',
      airport_type: 2,
      airport_name: 'Dabolim Arpt',
      airport_code: 'GOI',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 932,
      city_code: 'MAA',
      city_name: 'Chennai',
      airport_type: 2,
      airport_name: 'Chennai Arpt',
      airport_code: 'MAA',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
  ];

  travellInfoData = [
    {
      imagesUrl: 'assets/main/priority.png',
      title: 'Important Guideline',
      text: 'Click here in order to cancel/claim refund on your recent booking or reschedule/modify your booking.',
    },
    {
      imagesUrl: 'assets/main/travel-guide.png',
      title: 'Travel Guide',
      text: 'Get latest information on airlines & airports guidelines, state-wise quarantine rules, travel checklists, web-checkin, etc.',
    },
    {
      imagesUrl: 'assets/main/refund_new.png',
      title: 'FREE Full Refund',
      text: 'Get full refund for domestic ticket in case you cancel it due to medical reasons. Exclusively on CheapTicket.in',
    },
  ];
  bookWithUsData = [
    {
      imagesUrl: 'assets/belairtrip_assets/svg_icon/count.svg',
      title: 'Lowest Available Fare',
      text: 'Unbeatable prices on Flights to all destinations. Search for the best available fares from Anywhere to Anywhere.',
    },
    {
      imagesUrl: 'assets/belairtrip_assets/svg_icon/discout.svg',
      title: 'Exciting Deals',
      text: 'Offering most discounted fares & tariffs on Belairtrip.com. Our deals are made to help you save big.',
    },
    // {
    //   imagesUrl: 'assets/belairtrip_assets/svg_icon/customer-service.svg',
    //   title: '24x7 Support',
    //   text: 'Our customers are our top priority. Reach out to us anytime with assurance that your concerns will be promptly addressed.',
    // },
    {
      imagesUrl: 'assets/belairtrip_assets/svg_icon/click-to-book.png',
      title: 'Click-to-Book',
      text: 'Enjoy flight bookings with attractive offers and discounts. Book flights from anywhere to anywhere with just one click — Look, Book, Fly.',
    }
  ];
  form_type = [
    { value: 'flight_booking', name: 'Flight Booking' },
    // { value: 'sevices', name: 'Services' },
    { value: 'feedback', name: 'Feedback' },
    // { value: 'management', name: 'Management' },
  ];
  booking_subject = [
    { name: 'E-ticket Copy', value: 'e-ticket Copy' },
    { name: 'Flight Change', value: 'flight Change' },
    { name: 'Date Change', value: 'date Change' },
    { name: 'Schedule Change', value: 'schedule Change' },
    { name: 'Cancellation', value: 'Cancellation' },
    { name: 'Refunds', value: 'Refunds' },
    { name: 'Seat Request', value: 'Seat Request' },
    { name: 'Name Correction', value: 'Name Correction' },
    { name: 'Unaccompanied Minor', value: 'Unaccompanied Minor' },
    { name: 'Meal Request', value: 'Meal Request' },
    { name: 'Child Meal', value: 'Child Meal' },
    { name: 'Baby Meal', value: 'Baby Meal' },
    { name: 'Baby Basinett', value: 'Baby Basinett' },
    { name: 'Wheel Chair', value: 'Wheel Chair' },
    { name: 'Frequent Flyer', value: 'Frequent Flyer' },
    { name: 'Baggage', value: 'Baggage' },
    { name: 'Pets Request', value: 'Pets Request' },
    { name: 'Others', value: 'Others' },
  ];
  Feedback_type = [
    { name: 'Complaints', value: 'Complaints' },
    { name: 'Suggestion', value: 'suggestion' },
    { name: 'Disputes', value: 'Disputes' },
    { name: 'Comments', value: 'Comments' },
    { name: 'Others', value: 'Others' },
  ];
  Journey_type = [
    { name: 'DOMESTIC ONE WAY', value: 'DOMESTIC ONE WAY' },
    { name: 'DOMESTIC ROUND TRIP', value: 'DOMESTIC ROUND TRIP' },
    { name: 'INTERNATIONAL ONE WAY', value: 'INTERNATIONAL ONE WAY' },
    { name: 'INTERNATIONAL ROUND TRIP', value: 'INTERNATIONAL ROUND TRIP' },
    { name: 'FLIGHT', value: 'FLIGHT' },
  ];
  payment_mode = [
    { name: 'CREDIT CARD', value: 'CREDIT CARD' },
    { name: 'DEBIT CARD', value: 'DEBIT CARD' },
    { name: 'NET BANKING', value: 'NET BANKING' },
    { name: 'CASH DEPOSIT', value: 'CASH DEPOSIT' },
    { name: 'MONEY WALLET', value: 'MONEY WALLET' },
    { name: 'OTHER', value: 'OTHER' },
  ];
  management_subject = [
    { name: 'Co-Operation', value: 'Co-Operation' },
    { name: 'Alliances', value: 'Alliances' },
    { name: 'Technology', value: 'Technology' },
    { name: 'Supplier', value: 'Supplier' },
    { name: 'Buyer', value: 'Buyer' },
    { name: 'Advertising', value: 'Advertising' },
    { name: 'Marketing', value: 'Marketing' },
    { name: 'White Label', value: 'White Label' },
    { name: 'API', value: 'API' },
    { name: 'Financial Services', value: 'Financial Services' },
    { name: 'Partner with us', value: 'Partner with us' },
    { name: 'Others', value: 'Others' },
    // {name: "", value: ""},
  ];
  information_type = [
    { name: 'Passport', value: 'Passport' },
    { name: 'Visa', value: 'Visa' },
    { name: 'Travel Insurance', value: 'Travel Insurance' },
    { name: 'Airport Assistance', value: 'Airport Assistance' },
    { name: 'Vaccination', value: 'Vaccination' },
    { name: 'Others', value: 'Others' },
  ];
  travel_type = [
    { name: 'Round Trip', value: 'Round Trip' },
    { name: 'One Way', value: 'One Way' },
    { name: 'Multi City', value: 'Multi City' },
    { name: 'Flight + Hotels', value: 'Flight + Hotels' },
    { name: 'Others', value: 'Others' },
  ];
  assistance_type = [
    { name: 'COMPANION OFFER', value: 'COMPANION OFFER' },
    { name: 'STUDENT FARES', value: 'STUDENT FARES' },
    { name: 'DOMESTIC GROUP FARE', value: 'DOMESTIC GROUP FARE' },
    { name: 'INTERNATIONAL GROUP', value: 'INTERNATIONAL GROUP' },
    { name: 'PROMO CODE', value: 'PROMO CODE' },
    { name: 'DISCOUNT CODE', value: 'DISCOUNT CODE' },
    { name: 'CHARTER FLIGHTS', value: 'CHARTER FLIGHTS' },
    { name: 'HOTEL BOOKING', value: 'HOTEL BOOKING' },
    { name: 'CAR RENTAL', value: 'CAR RENTAL' },
    { name: 'TRANSFERS', value: 'TRANSFERS' },
    { name: 'HOLIDAYS', value: 'HOLIDAYS' },
    { name: 'CORPORATE OFFERS', value: 'CORPORATE OFFERS' },
    { name: 'OTHERS', value: 'OTHERS' },
  ];
  qualification_type = [
    { name: 'PhD', value: 'PhD' },
    { name: 'Post Graduate', value: 'post graduate' },
    { name: 'Graduate', value: 'graduate' },
    { name: 'High School', value: 'High School' },
    { name: 'Metric', value: 'Metric' },
    { name: 'IT Engineer', value: 'IT Engineer' },
    { name: 'Programmer', value: 'Programmer' },
    { name: 'Web Designer', value: 'Web Designer' },
    { name: 'Graphic Designer', value: 'Graphic Designer' },
    { name: 'Content Writer', value: 'Content Writer' },
    { name: 'Charted Account', value: 'Charted Account' },
    { name: 'MBA / Masters', value: 'MBA / Masters' },
    { name: 'Secretarial Services', value: 'Secretarial Services' },
    { name: 'Others', value: 'Others' },
  ];
  job_type = [
    { name: 'Reservations', value: 'Reservations' },
    { name: 'Ticket Exchange', value: 'Ticket Exchange' },
    { name: 'Smart Ticketing', value: 'Smart Ticketing' },
    { name: 'BSP', value: 'BSP' },
    { name: 'Maintenance Engineer', value: 'Maintenance Engineer' },
    { name: 'Hardware Engineer', value: 'Hardware Engineer' },
    { name: 'Software Engineer', value: 'Software Engineer' },
    { name: 'IT', value: 'IT' },
    { name: 'PHP Developers', value: 'PHP Developers' },
    { name: 'Graphic Designer', value: 'Graphic Designer' },
  ];
  location_type = [
    { name: 'New Delhi', value: 'new delhi' },
    { name: 'Noida', value: 'noida' },
  ];

  travelFrom = [
    {
      id: 1236,
      city_code: 'DEL',
      city_name: 'New Delhi',
      airport_type: 2,
      airport_name: 'Delhi Indira Gandhi Intl',
      airport_code: 'DEL',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 946,
      city_code: 'BOM',
      city_name: 'Mumbai',
      airport_type: 2,
      airport_name: 'Chhatrapati Shivaji',
      airport_code: 'BOM',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 2463,
      city_code: 'BLR',
      city_name: 'Bengaluru',
      airport_type: 2,
      airport_name: 'Kempegowda Intl Arpt',
      airport_code: 'BLR',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 1169,
      city_code: 'GOI',
      city_name: 'Goa',
      airport_type: 2,
      airport_name: 'Dabolim Arpt',
      airport_code: 'GOI',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 932,
      city_code: 'MAA',
      city_name: 'Chennai',
      airport_type: 2,
      airport_name: 'Chennai Arpt',
      airport_code: 'MAA',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 4147,
      city_code: 'HYD',
      city_name: 'Hyderabad',
      airport_type: 2,
      airport_name: 'Rajiv Gandhi Intl',
      airport_code: 'HYD',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 3535,
      city_code: 'CCU',
      city_name: 'Kolkata',
      airport_type: 2,
      airport_name: 'Netaji Subhas Chandra Bose Intl',
      airport_code: 'CCU',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 2893,
      city_code: 'PNQ',
      city_name: 'Pune',
      airport_type: 2,
      airport_name: 'Lohegaon Arpt',
      airport_code: 'PNQ',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 5352,
      city_code: 'VTZ',
      city_name: 'Vishakhapatanam',
      airport_type: 2,
      airport_name: 'Vishakhapatnam',
      airport_code: 'VTZ',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 166,
      city_code: 'LKO',
      city_name: 'Lucknow',
      airport_type: 2,
      airport_name: 'Amausi Arpt',
      airport_code: 'LKO',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 2702,
      city_code: 'VNS',
      city_name: 'Varanasi',
      airport_type: 2,
      airport_name: 'Lal Bahadur Shastri Arpt',
      airport_code: 'VNS',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },

    {
      id: 4501,
      city_code: 'AMD',
      city_name: 'Ahmedabad',
      airport_type: 2,
      airport_name: 'Sardar Vallabh Bhai Patel Intl Arpt',
      airport_code: 'AMD',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 4145,
      city_code: 'ATQ',
      city_name: 'Amritsar',
      airport_type: 3,
      airport_name: 'Raja Sansi Arpt',
      airport_code: 'ATQ',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 545,
      city_code: 'BBI',
      city_name: 'Bhubaneswar',
      airport_type: 2,
      airport_name: 'Biju Patnaik Arpt',
      airport_code: 'BBI',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 2895,
      city_code: 'GAU',
      city_name: 'Guwahati',
      airport_type: 2,
      airport_name: 'Lokpriya Gopinath Bordoloi Intl Arpt',
      airport_code: 'GAU',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },

    {
      id: 891,
      city_code: 'IXC',
      city_name: 'Chandigarh',
      airport_type: 2,
      airport_name: 'Chandigarh Arpt',
      airport_code: 'IXC',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      airport_code: 'LHR',
      airport_name: 'Heathrow',
      airport_type: 2,
      city_code: 'LON',
      city_name: 'London',
      country_code: 'GB',
      id: 2014,
      is_top: 1,
      timezone: 'Europe/London',
    },
  ];

  travelTo = [
    {
      airport_code: 'LHR',
      airport_name: 'Heathrow',
      airport_type: 2,
      city_code: 'LON',
      city_name: 'London',
      country_code: 'GB',
      id: 2014,
      is_top: 1,
      timezone: 'Europe/London',
    },
    {
      id: 946,
      city_code: 'BOM',
      city_name: 'Mumbai',
      airport_type: 2,
      airport_name: 'Chhatrapati Shivaji',
      airport_code: 'BOM',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 2463,
      city_code: 'BLR',
      city_name: 'Bengaluru',
      airport_type: 2,
      airport_name: 'Kempegowda Intl Arpt',
      airport_code: 'BLR',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 1169,
      city_code: 'GOI',
      city_name: 'Goa',
      airport_type: 2,
      airport_name: 'Dabolim Arpt',
      airport_code: 'GOI',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 1236,
      city_code: 'DEL',
      city_name: 'New Delhi',
      airport_type: 2,
      airport_name: 'Delhi Indira Gandhi Intl',
      airport_code: 'DEL',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },

    {
      id: 932,
      city_code: 'MAA',
      city_name: 'Chennai',
      airport_type: 2,
      airport_name: 'Chennai Arpt',
      airport_code: 'MAA',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 4147,
      city_code: 'HYD',
      city_name: 'Hyderabad',
      airport_type: 2,
      airport_name: 'Rajiv Gandhi Intl',
      airport_code: 'HYD',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 3535,
      city_code: 'CCU',
      city_name: 'Kolkata',
      airport_type: 2,
      airport_name: 'Netaji Subhas Chandra Bose Intl',
      airport_code: 'CCU',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 2893,
      city_code: 'PNQ',
      city_name: 'Pune',
      airport_type: 2,
      airport_name: 'Lohegaon Arpt',
      airport_code: 'PNQ',
      country_code: 'IN',
      is_top: 1,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 5352,
      city_code: 'VTZ',
      city_name: 'Vishakhapatanam',
      airport_type: 2,
      airport_name: 'Vishakhapatnam',
      airport_code: 'VTZ',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 166,
      city_code: 'LKO',
      city_name: 'Lucknow',
      airport_type: 2,
      airport_name: 'Amausi Arpt',
      airport_code: 'LKO',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 2702,
      city_code: 'VNS',
      city_name: 'Varanasi',
      airport_type: 2,
      airport_name: 'Lal Bahadur Shastri Arpt',
      airport_code: 'VNS',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },

    {
      id: 4501,
      city_code: 'AMD',
      city_name: 'Ahmedabad',
      airport_type: 2,
      airport_name: 'Sardar Vallabh Bhai Patel Intl Arpt',
      airport_code: 'AMD',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 4145,
      city_code: 'ATQ',
      city_name: 'Amritsar',
      airport_type: 3,
      airport_name: 'Raja Sansi Arpt',
      airport_code: 'ATQ',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 545,
      city_code: 'BBI',
      city_name: 'Bhubaneswar',
      airport_type: 2,
      airport_name: 'Biju Patnaik Arpt',
      airport_code: 'BBI',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
    {
      id: 2895,
      city_code: 'GAU',
      city_name: 'Guwahati',
      airport_type: 2,
      airport_name: 'Lokpriya Gopinath Bordoloi Intl Arpt',
      airport_code: 'GAU',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },

    {
      id: 891,
      city_code: 'IXC',
      city_name: 'Chandigarh',
      airport_type: 2,
      airport_name: 'Chandigarh Arpt',
      airport_code: 'IXC',
      country_code: 'IN',
      is_top: 0,
      timezone: 'Asia/Calcutta',
    },
  ];

  topLocationHotel = [
    {
      id: 147,
      code: 'DEL',
      name: 'Delhi and NCR',
      state: { id: null, code: null, name: 'Delhi and Ncr' },
      country: { id: 105, code: 'IN', name: 'India' },
    },
    {
      id: 135,
      code: 'Mumbai',
      name: 'Mumbai',
      state: { id: 572, code: 'Maharasthra', name: 'Mumbai' },
      country: { id: 105, code: 'IN', name: 'India' },
    },
    {
      id: 6019,
      code: 'Patnem, Canacona, Goa',
      name: 'Patnem, Canacona, Goa',
      state: { id: 9, code: 'Goa', name: 'Goa' },
      country: { id: 105, code: 'IN', name: 'India' },
    },
    {
      id: 5865,
      code: '171001, Shimla, Himachal Pradesh',
      name: 'Shimla, Himachal Pradesh',
      state: { id: 380, code: 'Himachal Pradesh', name: 'Shimla' },
      country: { id: 105, code: 'IN', name: 'India' },
    },
    {
      id: 147,
      code: 'DEL',
      name: 'Bangalore',
      state: { id: null, code: null, name: 'Bangalore' },
      country: { id: 105, code: 'IN', name: 'India' },
    },
    {
      id: 135,
      code: 'Chennai',
      name: 'Chennai',
      state: { id: 572, code: 'Tamil nadu', name: 'Chennai' },
      country: { id: 105, code: 'IN', name: 'India' },
    },
    {
      id: 6019,
      code: 'Hyderabad',
      name: 'Hyderabad',
      state: { id: 9, code: 'Hyderabad', name: 'Hyderabad' },
      country: { id: 105, code: 'IN', name: 'India' },
    },
    {
      id: 5865,
      code: 'Kolkata',
      name: 'Kolkata',
      state: { id: 380, code: 'Kolkata', name: 'Kolkata' },
      country: { id: 105, code: 'IN', name: 'India' },
    },
    {
      id: 5865,
      code: 'Pune',
      name: 'Pune',
      state: { id: 380, code: 'Pune', name: 'Pune' },
      country: { id: 105, code: 'IN', name: 'India' },
    },
    {
      id: 5865,
      code: 'Agra',
      name: 'Agra',
      state: { id: 380, code: 'Uttar Pradesh', name: 'Agra' },
      country: { id: 105, code: 'IN', name: 'India' },
    },
  ];

  getTitle(name) {
    return name ? this.title.find((i) => i.id === name)?.name : null;
  }

  getType(name) {
    return name ? this.travelType.find((i) => i.id === name)?.name : null;
  }

  getFlagIcon(flag) {
    return flag ? this.numbers.find((i) => i.code === flag)?.flag : null;
  }

  
  constructor() {
    const svgFolderPath = 'assets/svgIcon/country-flag/';
  this.numbers = this.numbers.map((country) => ({
    ...country,
    flag: `${svgFolderPath}${country.code.toLowerCase()}.svg`,
  }));
  }
}
